<ng-container *ngIf="(layout$ | async)?.logo.isHyperLink">
  <a 
    href="https://www.biodigital.com"
    target="_blank"
    class="view-logo"
    [ngClass]="{
      'view-logo--full-color': isLight && (breakpoint$ | async) > viewBreakpoint.Small,
      'view-logo--full-white': !isLight && (breakpoint$ | async) > viewBreakpoint.Small,
      'view-logo--small-color': isLight && (breakpoint$ | async) === viewBreakpoint.Small,
      'view-logo--small-white': !isLight && (breakpoint$ | async) === viewBreakpoint.Small
    }">
  </a>
</ng-container>

<ng-container *ngIf="!(layout$ | async)?.logo.isHyperLink">
  <span 
    class="view-logo"
    [ngClass]="{
      'view-logo--full-color': isLight && (breakpoint$ | async) > viewBreakpoint.Small,
      'view-logo--full-white': !isLight && (breakpoint$ | async) > viewBreakpoint.Small,
      'view-logo--small-color': isLight && (breakpoint$ | async) === viewBreakpoint.Small,
      'view-logo--small-white': !isLight && (breakpoint$ | async) === viewBreakpoint.Small
    }">
  </span>
</ng-container>